import HttpRequest from '@/libs/axios'
//import config from '@/config'
// const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
// const baseUrl = "http://www.ztszx.gov.cn/"
const baseUrl = "http://hs.tlhs2022.cn/"
//const baseUrl = "http://192.168.3.75:96/"
const axios = new HttpRequest(baseUrl)
export default axios